<script setup lang="ts">
import { partIcons, PartType, PartTypesShortNames } from '@/types/rc/miners/PartType'
import { computed } from 'vue'
import { Icon } from '@iconify/vue'

const props = withDefaults(defineProps<{ allowMiner?: boolean; shortNames?: boolean }>(), {
  allowMiner: false,
  shortNames: false,
})
const selectedPartType = defineModel<PartType>()

const partsAvailable = computed(() =>
  [PartType.PowerSupply, PartType.ControlBoard, PartType.Hashboard, PartType.Fan].concat(
    props.allowMiner ? [PartType.Miner] : []
  )
)
</script>

<template>
  <el-select v-model="selectedPartType">
    <el-option
      v-for="partType in partsAvailable"
      :key="partType"
      :label="PartTypesShortNames[partType]"
      :value="partType"
    >
      <span class="part-type-option">
        <Icon :icon="partIcons[partType]" /><span>{{ shortNames ? PartTypesShortNames[partType] : partType }}</span>
      </span>
    </el-option>
    <template v-if="selectedPartType" #label>
      <span class="part-type-option">
        <Icon :icon="partIcons[selectedPartType]" class="shrink-0" />
        <span>{{ shortNames ? PartTypesShortNames[selectedPartType] : selectedPartType }}</span>
      </span>
    </template>
  </el-select>
</template>

<style lang="scss" scoped>
.part-type-option {
  display: flex;
  align-items: center;
  gap: var(--spacing-spacing-xs);
}
</style>
